<template>
  <div id="park-list" class="park-list">
    <div class="search-box">
      <el-form :model="search" ref="search">
        <el-row>
          <el-col :span="8" style="margin-right: 20px">
            <el-form-item prop="name">
              <el-autocomplete
                prefix-icon="el-icon-search"
                v-model="search.projectName"
                :fetch-suggestions="querySearch"
                @select="handleSelect"
                style="width: 100%"
                placeholder="请输入产业、行政区划、开发区、项目名称"
                clearable
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <div class="search-btn">
            <el-button type="primary" icon="el-icon-search" @click="searchList"
              >查询
            </el-button>
            <el-button icon="el-icon-refresh-right" @click="refreshList">
              重置刷新
            </el-button>
            <div class="develop" @click="develop">
              <el-button type="primary" :icon="iconDown" @click="searchList"
                >高级搜索
              </el-button>
            </div>
          </div>
        </el-row>
        <el-collapse-transition>
          <div v-show="showList2">
            <div class="title-select">
              <!--行政区划-->
              <el-row class="bottom-line-dashed">
                <el-col :span="2"
                  ><span class="tool-title">行政区划:</span></el-col
                >
                <el-col :span="21">
                  <div
                    class="content"
                    :class="[isXzqhShrink ? 'shrink' : '']"
                    v-for="item in xzqhList"
                    :key="item.id"
                  >
                    <el-input
                      v-model="countyName"
                      @change="changeCounty"
                      @clear="
                        countyList = [];
                        showList = false;
                        xzqh.zs = null;
                        xzqh.qx = null;
                        isXzqhShrink = true;
                      "
                      style="width: 120px"
                      clearable
                    ></el-input>
                    <span
                      :class="[xzqh.zs ? '' : 'span-active']"
                      @click="
                        (xzqh.zs = null),
                          (xzqh.qx = null),
                          (countyName = ''),
                          (search.county = null),
                          searchList()
                      "
                      >全部</span
                    >

                    <span
                      v-for="(zs, index) in item.children"
                      :key="index"
                      :class="[xzqh.zs == zs ? 'span-active' : '']"
                      @click="
                        (xzqh.zs = xzqh.zs == zs ? null : zs), (xzqh.qx = null)
                      "
                    >
                      <!-- <i class="color-4" v-if="index < 4">hot</i> -->
                      {{ zs.label }}
                      <!-- <i class="iconfont icon-remen color-2" v-if="index < 4"></i> -->
                    </span>
                    <div
                      class="more"
                      v-if="isXzqhShrink"
                      @click="isXzqhShrink = !isXzqhShrink"
                    >
                      ...更多
                    </div>
                    <div
                      class="shrink-btn"
                      v-if="!isXzqhShrink"
                      @click="isXzqhShrink = !isXzqhShrink"
                    >
                      收起
                    </div>
                  </div>
                  <!-- isXzqhShrink ? 'shrink-child' : '', -->
                  <div
                    :class="['content content2']"
                    v-if="xzqh.zs && !isXzqhShrink"
                  >
                    <span
                      v-for="(qx, qxIndex) in xzqh.zs.children"
                      :key="qxIndex"
                      :class="xzqh.zs && xzqh.qx == qx ? 'span-active' : ''"
                      @click="xzqh.qx = xzqh.qx == qx ? null : qx"
                      >{{ qx.label }}</span
                    >
                  </div>
                </el-col>
                <div class="input-box scrollbar-definition" v-show="showList">
                  <div
                    v-for="(item, index) in countyList"
                    :key="index"
                    @click="selectCounty(item)"
                  >
                    {{ item.name }}
                  </div>
                  <div
                    v-if="showList && !countyList.length"
                    @click="showList = false"
                  >
                    无匹配数据
                  </div>
                </div>
              </el-row>
              <!--开发区-->
              <el-row class="bottom-line-dashed">
                <el-col :span="2"
                  ><span class="tool-title">开发区:</span></el-col
                >
                <el-col :span="21">
                  <div class="content" :class="[isShrink ? 'shrink' : '']">
                    <el-input
                      v-model="parkName"
                      @change="changePark"
                      @clear="countyParkList = []"
                      style="width: 120px"
                      clearable
                    ></el-input>
                    <span
                      :class="[search.parkCode == '' ? 'span-active' : '']"
                      @click="
                        search.parkCode = '';
                        search.parkLevel = '';
                        searchList();
                        getPark();
                      "
                      >全部</span
                    >
                    <span
                      :class="[
                        search.parkLevel == item.value ? 'span-active' : '',
                      ]"
                      v-for="(item, index) in parkLevel"
                      :key="index"
                      @click="searchPark(item, index)"
                    >
                      {{ item.name }}
                    </span>
                    <div
                      class="more"
                      v-if="isShrink"
                      @click="isShrink = !isShrink"
                    >
                      ...更多
                    </div>
                    <div
                      class="shrink-btn"
                      v-if="!isShrink"
                      @click="isShrink = !isShrink"
                    >
                      收起
                    </div>
                    <!-- <span
                      :class="[search.parkCode == '' ? 'span-active' : '']"
                      @click="(search.parkCode = ''), searchList()"
                      >全部</span
                    >
                    <span
                      :class="[
                        search.parkCode == item.parkCode ? 'span-active' : '',
                      ]"
                      v-for="(item, index) in parkList"
                      :key="index"
                      @click="
                        (search.parkCode =
                          search.parkCode == item.parkCode
                            ? null
                            : item.parkCode),
                          searchList()
                      "
                      >{{ item.parkName }}</span
                    >
                    <div
                      class="more"
                      v-if="isShrink"
                      @click="isShrink = !isShrink"
                    >
                      ...更多
                    </div>
                    <div
                      class="shrink-btn"
                      v-if="!isShrink"
                      @click="isShrink = !isShrink"
                    >
                      收起
                    </div> -->
                  </div>
                  <div :class="['content content2']" v-if="!isShrink">
                    <span
                      v-for="(j, i) in parkList"
                      :key="i"
                      :class="
                        search.parkCode == j.parkCode ? 'span-active' : ''
                      "
                      @click="
                        search.parkCode =
                          search.parkCode == j.parkCode ? null : j.parkCode;
                        searchList();
                      "
                      >{{ j.parkName }}</span
                    >
                  </div>
                </el-col>
                <div
                  class="input-box scrollbar-definition"
                  v-show="showParkList"
                >
                  <div
                    v-for="(item, index) in countyParkList"
                    :key="index"
                    @click="selectCountyPark(item)"
                  >
                    {{ item.parkName }}
                  </div>
                  <div
                    v-if="showParkList && !countyParkList.length"
                    @click="showParkList = false"
                  >
                    无匹配数据
                  </div>
                </div>
              </el-row>
              <!--土地用途-->
              <!-- <el-row class="bottom-line-dashed">
                <el-col :span="2"
                  ><span class="tool-title">土地用途:</span></el-col
                >
                <el-col :span="20">
                  <div class="content">
                    <span
                      :class="tdyt.lv1 ? '' : 'span-active'"
                      @click="(tdyt.lv1 = null), (tdyt.lv2 = null)"
                      >全部</span
                    >
                    <span
                      v-for="(item, index) in tdytList"
                      :key="index"
                      :class="tdyt.lv1 == item ? 'span-active' : ''"
                      @click="(tdyt.lv1 = item), (tdyt.lv2 = null)"
                      >{{ item.name }}</span
                    >
                  </div>
                  <div class="content content2" v-if="tdyt.lv1">
                    <span
                      v-for="(item, index) in tdyt.lv1.child"
                      :key="index"
                      :class="tdyt.lv1 && tdyt.lv2 == item ? 'span-active' : ''"
                      @click="tdyt.lv2 = item"
                      >{{ item.name }}</span
                    >
                  </div>
                </el-col>
              </el-row> -->

              <!--标签-->
              <el-row>
                <el-col :span="2"><span class="tool-title">产业:</span></el-col>
                <el-col :span="20">
                  <div class="content" :class="[isindustry ? 'shrink' : '']">
                    <span
                      :class="[
                        search.industryChainCategoryId == ''
                          ? 'span-active'
                          : '',
                      ]"
                      @click="
                        search.industryChainCategoryId = '';
                        search.labelName = '';
                        searchList();
                      "
                      >全部</span
                    >
                    <span
                      v-for="(item, index) in labelList"
                      :key="index"
                      :class="[
                        search.industryChainCategoryId == item.labelId
                          ? 'span-active'
                          : '',
                      ]"
                      @click="
                        search.industryChainCategoryId =
                          search.industryChainCategoryId == item.labelId
                            ? ''
                            : item.labelId;
                        search.labelName =
                          search.labelName == item.labelName
                            ? ''
                            : item.labelName;
                        cyIndex = cyIndex == index ? -1 : index;
                        searchList();
                      "
                      >{{ item.labelName }}</span
                    >
                    <div
                      class="more"
                      v-if="isindustry"
                      @click="isindustry = !isindustry"
                    >
                      ...更多
                    </div>
                    <div
                      class="shrink-btn"
                      v-if="!isindustry"
                      @click="isindustry = !isindustry"
                    >
                      收起
                    </div>
                  </div>
                  <!-- <div
                    :class="['content content2']"
                    v-if="!isindustry && cyIndex != -1"
                  >
                    <span
                      v-for="(item, index1) in labelList[cyIndex].childs"
                      :key="index1"
                      :class="[
                        search.industryChainCategoryId == item.labelId
                          ? 'span-active'
                          : '',
                      ]"
                      @click="
                        cyIndex =
                          search.industryChainCategoryId == item.labelId
                            ? -1
                            : cyIndex;
                        search.industryChainCategoryId =
                          search.industryChainCategoryId == item.labelId
                            ? ''
                            : item.labelId;
                        search.labelName =
                          search.labelName == item.labelName
                            ? ''
                            : item.labelName;
                        searchList();
                      "
                    >
                      {{ item.labelName }}
                    </span>
                  </div> -->
                </el-col>
                <!-- <el-col :span="20">
                  <div class="content">
                    <span :class="[search.label == '' ? 'span-active' : '']" @click="
                      search.industryChainCategoryId = '';
                    searchList();
                    ">全部</span>
                    <span v-for="(item, index) in labelList" :key="index" :class="[
                      search.label == item.labelId ? 'span-active' : '',
                    ]" @click="
  search.industryChainCategoryId = item.industryChainId;
search.label = item.labelId;
searchList();
">{{ item.labelName }}</span>
                  </div>
                </el-col> -->
              </el-row>
              <el-row class="bottom-line-dashed">
                <el-col :span="2"
                  ><span class="tool-title">投资估算:</span></el-col
                >
                <el-col :span="6">
                  <el-input
                    type="number"
                    v-model="search.minInvestmentEstimate"
                    class="need-area-input"
                  ></el-input>
                  <span style="font-size: 12px">亿元</span>
                  -
                  <el-input
                    type="number"
                    v-model="search.maxInvestmentEstimate"
                    class="need-area-input"
                  ></el-input>
                  <span style="font-size: 12px">亿元</span>
                </el-col>
                <el-col :span="16">
                  <div class="content">
                    <span
                      :class="estimateIndx == -1 ? 'span-active' : ''"
                      @click="
                        (search.minInvestmentEstimate = null),
                          (search.maxInvestmentEstimate = null),
                          searchList(),
                          (estimateIndx = -1)
                      "
                    >
                      全部
                    </span>
                    <span
                      v-for="(item, index) in estimateList"
                      :key="index"
                      @click="handleEstimate(item, index)"
                      :class="index == estimateIndx ? 'span-active' : ''"
                    >
                      {{ item.minmoney }} 亿元{{ item.maxmoney ? "-" : "以上"
                      }}{{ item.maxmoney }} {{ item.maxmoney ? "亿元" : "" }}
                    </span>
                  </div>
                </el-col>
              </el-row>

              <el-row class="bottom-line-dashed">
                <el-col :span="2"
                  ><span class="tool-title">拟用地面积:</span></el-col
                >
                <el-col :span="6">
                  <el-input
                    type="number"
                    v-model="search.minArea"
                    class="need-area-input"
                  ></el-input>
                  <span style="font-size: 12px">亩</span>
                  -
                  <el-input
                    type="number"
                    v-model="search.maxArea"
                    class="need-area-input"
                  ></el-input>
                  <span style="font-size: 12px">亩</span>
                </el-col>
                <el-col :span="10">
                  <div class="content">
                    <span
                      :class="areaIndx == -1 ? 'span-active' : ''"
                      @click="
                        ((search.minArea = null),
                        (search.maxArea = null),
                        (areaIndx = -1)),
                          searchList()
                      "
                    >
                      全部
                    </span>
                    <span
                      v-for="(item, index) in areaList"
                      :key="index"
                      @click="handleArea(item, index)"
                      :class="index == areaIndx ? 'span-active' : ''"
                    >
                      {{ item.minarea }}亩{{ item.maxarea ? "-" : "以上"
                      }}{{ item.maxarea }}{{ item.maxarea ? "亩" : "" }}
                    </span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-collapse-transition>
      </el-form>
    </div>

    <div
      class="table-box"
      v-if="tableList.length || loading"
      v-loading="loading"
    >
      <div
        class="card-base"
        v-for="(item, index) in tableList"
        :key="index"
        :style="{ marginRight: index + 1 == 5 || index + 1 == 10 ? 0 : '' }"
        @click="
          $router.push({
            path: '/project/detail',
            query: { id: item.id },
          })
        "
      >
        <div class="card-base-box">
          <div class="card-base-box-top">
            <div style="width: 100%; height: 160px">
              <img
                v-show="item.imgUrl"
                :src="item.imgUrl"
                alt=""
                style="width: 100%; height: 100%"
              />
              <!-- <div v-for="()"></div> -->
              <img
                v-show="
                  !item.imgUrl &&
                  item.industryChainCategory == '高原特色现代农业'
                "
                :src="projectbglist[0].urlbg"
                alt=""
                style="width: 100%; height: 100%"
              />
              <img
                v-show="!item.imgUrl && item.industryChainCategory == '绿色铝'"
                :src="projectbglist[1].urlbg"
                alt=""
                style="width: 100%; height: 100%"
              />
              <img
                v-show="
                  !item.imgUrl && item.industryChainCategory == '光伏制造业'
                "
                :src="projectbglist[2].urlbg"
                alt=""
                style="width: 100%; height: 100%"
              />
              <img
                v-show="
                  !item.imgUrl && item.industryChainCategory == '先进制造业'
                "
                :src="projectbglist[3].urlbg"
                alt=""
                style="width: 100%; height: 100%"
              />
              <img
                v-show="
                  !item.imgUrl && item.industryChainCategory == '绿色能源产业'
                "
                :src="projectbglist[4].urlbg"
                alt=""
                style="width: 100%; height: 100%"
              />
              <img
                v-show="
                  !item.imgUrl && item.industryChainCategory == '现代物流业'
                "
                :src="projectbglist[5].urlbg"
                alt=""
                style="width: 100%; height: 100%"
              />
              <img
                v-show="
                  !item.imgUrl && item.industryChainCategory == '新材料产业'
                "
                :src="projectbglist[6].urlbg"
                alt=""
                style="width: 100%; height: 100%"
              />
              <img
                v-show="
                  !item.imgUrl && item.industryChainCategory == '生物医药产业'
                "
                :src="projectbglist[7].urlbg"
                alt=""
                style="width: 100%; height: 100%"
              />
              <img
                v-show="
                  !item.imgUrl && item.industryChainCategory == '数字经济'
                "
                :src="projectbglist[8].urlbg"
                alt=""
                style="width: 100%; height: 100%"
              />
              <img
                v-show="
                  !item.imgUrl && item.industryChainCategory == '出口导向产业'
                "
                :src="projectbglist[9].urlbg"
                alt=""
                style="width: 100%; height: 100%"
              />
              <img
                v-show="
                  !item.imgUrl && item.industryChainCategory == '文旅康养产业'
                "
                :src="projectbglist[10].urlbg"
                alt=""
                style="width: 100%; height: 100%"
              />
              <img
                v-show="!item.imgUrl && item.industryChainCategory == '其他'"
                :src="projectbglist[11].urlbg"
                alt=""
                style="width: 100%; height: 100%"
              />
            </div>
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.projectName"
              placement="bottom"
            >
              <div class="card-base-box-title">
                {{ item.projectName }}
              </div>
            </el-tooltip>
            <div class="card-base-box-center">
              <div
                type="success"
                size="medium"
                effect="dark"
                class="card-base-box-center-tag tag1"
                v-if="item.industryChainCategory"
              >
                {{ item.industryChainCategory }}
              </div>
              <div
                v-if="item.investmentEstimate"
                class="card-base-box-center-tag tag2"
              >
                {{ item.investmentEstimate }}万元
              </div>
              <div v-if="item.area" class="card-base-box-center-tag tag3">
                {{ item.area }}亩
              </div>
              <el-tooltip placement="right" :open-delay="1000">
                <div slot="content">
                  浏览量：{{ item.statistical | filter_statistical }}
                </div>
                <div
                  class="card-base-box-center-tag pageView"
                  v-if="!isComparison"
                >
                  <browse :statistical="item.statistical"></browse>
                </div>
              </el-tooltip>
              <!-- <div
                class="card-base-box-center-tag tag4"
                v-if="item.projectType != null"
              >
                {{ item.projectType == 1 ? "用地类项目" : "非用地类项目" }}
              </div> -->
              <el-tag
                type="warning"
                size="medium"
                class="card-base-box-center-tag"
                effect="dark"
                v-if="item.industryCategory"
              >
                {{ item.industryCategory }}
              </el-tag>
            </div>
          </div>

          <div class="card-base-box-bottom">
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.parkName"
              placement="top-start"
              v-if="item.parkName"
            >
              <div class="card-base-box-bottom-l">
                {{ item.parkName }}
              </div>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.countyName"
              placement="top-start"
              v-else
            >
              <div class="card-base-box-bottom-l">
                {{ item.countyName }}
              </div>
            </el-tooltip>
            <!-- <div class="card-base-box-bottom-l" v-if="item.parkName">
              {{ item.parkName }}
            </div> -->
            <!-- <div class="card-base-box-bottom-l">
              {{ item.countyName }}
            </div> -->
            <div
              class="card-base-box-bottom-r"
              @click="
                $router.push({
                  path: '/project/detail',
                  query: { id: item.id },
                })
              "
            >
              项目详情 >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="park-list-table-no" v-show="!tableList.length && !loading">
      <div class="park-list-table-no-c">
        <div class="park-list-table-no-c-img">
          <img src="../../assets/images/common/1.png" alt="" />
        </div>
        <div class="park-list-table-no-c-span">
          抱歉，没有找到符合条件的结果，您可以去
        </div>
        <div class="park-list-table-no-c-btn" @click="releaseNeed">
          提交需求
        </div>
      </div>
    </div>
    <div class="page-box" v-if="tableList.length">
      <el-pagination
        :current-page="search.current"
        :page-sizes="[10, 20, 40, 80]"
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="search.size"
        layout=" prev, pager, next,total, jumper "
        :total="total"
      ></el-pagination>
    </div>
    <!-- 右侧工具栏 -->
    <tools></tools>
  </div>
</template>
<script>
import {
  dictionaries,
  getXzqhList,
  getTypeList,
  getCodeChildren,
} from "@/api/common";
import {
  getLabelList,
  getAdministrative,
  getCountyParkList,
  searchDefault,
} from "@/api/setting/investment";
import contrast from "./components/contrast";
import card from "./components/card";
import detailedList from "./components/detailedList";
import Driver from "driver.js";
import Browse from "@/components/currency/browse";
import Tools from "@/views/home/components/tools";
import img03 from "@/assets/images/land/ldkg1.png";
import img04 from "@/assets/images/land/jqkg1.png";
import img05 from "@/assets/images/land/jhkg1.png";
import { getProjectList, projectList } from "@/api/setting/project";

export default {
  name: "projectList",
  components: { card, contrast, detailedList, Browse, Tools },
  data() {
    return {
      img01: img03,
      img02: img04,
      img03: img05,
      countyName: "",
      search: {
        projectName: "",
        //  xzqh: [],
        county: "",
        minArea: null,
        maxArea: null,
        size: 10,
        current: 1,
        parkCode: "",
        approvalStatus: "",
        area: null,
        minInvestmentEstimate: null,
        maxInvestmentEstimate: null,
        industryChainCategoryId: "",
        // projectLevel:1,
        approvalStatus: 3,
        parkLevel: "",
      },
      area: [30, 60],
      total: 0,
      tableList: [],
      xzqhList: [],
      tdytList: [],
      loading: true,
      contrastList: [], //对比数组id
      isShow: false,
      isDetailedList: false, //清单
      isComparison: false,
      isShrink: true, //开发区是否展开
      isXzqhShrink: true, //行政区划是否展开
      xzqh: {
        //行政区划对象
        zs: null, //洲市
        qx: null, //区县
      },
      tdyt: {
        lv1: null, // 第一级
        lv2: null, //第二级
      }, //土地用途对象
      parkList: [],
      cityList: [],
      labelList: [],
      maxValue: 100,
      countyList: [], //搜索行政区划列表
      showList: false, //搜索行政区划列表是否显示
      parkName: "", //搜索园区名称
      countyParkList: [], //搜索园区列表
      showParkList: false, //搜索园区列表是否显示

      supplyPeriod1: false,
      supplyPeriod2: false,
      supplyPeriod3: false,
      restaurants: [],
      iconDown: "el-icon-arrow-down",
      showList2: true,
      estimateList: [
        {
          minmoney: "1",
          maxmoney: "10",
          // minmoney: "10000",
          // maxmoney: "100000",
        },
        {
          minmoney: "10",
          maxmoney: "50",
          // minmoney: "100000",
          // maxmoney: "500000",
        },
        {
          minmoney: "50",
          maxmoney: "100",
          // minmoney: "500000",
          // maxmoney: "1000000",
        },
        {
          minmoney: "100",
          maxmoney: "",
          // minmoney: "1000000",
          // maxmoney: ""
        },
      ],
      estimateIndx: -1,
      areaList: [
        { minarea: "0", maxarea: "100" },
        { minarea: "100", maxarea: "500" },
        { minarea: "500", maxarea: "1000" },
        { minarea: "1000", maxarea: "" },
      ],
      areaIndx: -1,
      cyIndex: -1,
      isindustry: true,
      projectbglist: [
        { urlbg: require("@/assets/project/gytsxdny.png") },
        { urlbg: require("@/assets/project/lslg.png") },
        { urlbg: require("@/assets/project/gfzd.png") },
        { urlbg: require("@/assets/project/xjzzy.png") },
        { urlbg: require("@/assets/project/lsnycy.png") },
        { urlbg: require("@/assets/project/xdwl.png") },
        { urlbg: require("@/assets/project/xclcy.png") },
        { urlbg: require("@/assets/project/swyycy.png") },
        { urlbg: require("@/assets/project/szjj.png") },
        { urlbg: require("@/assets/project/ckdxcy.png") },
        { urlbg: require("@/assets/project/wlkycy.png") },
        { urlbg: require("@/assets/project/qt.png") },
      ],
      parkLevel: [
        { value: "DZXQ", name: "滇中新区" },
        { value: "1", name: "国家级" },
        { value: "2", name: "省级" },
        // { value: "3", name: "其他" },
      ],
    };
  },

  watch: {
    "search.name": function (val) {
      if (val) {
        let list = JSON.parse(sessionStorage.getItem("landSearchList"))
          ? JSON.parse(sessionStorage.getItem("landSearchList"))
          : [];
        if (list.length) {
          let index = list.findIndex((item) => item.value == val);
          if (index == -1) {
            list.push({ value: val });
            sessionStorage.setItem("landSearchList", JSON.stringify(list));
          }
        } else {
          list.push({ value: val });
          sessionStorage.setItem("landSearchList", JSON.stringify(list));
        }
        this.restaurants = JSON.parse(sessionStorage.getItem("landSearchList"))
          ? JSON.parse(sessionStorage.getItem("landSearchList"))
          : [];
      }
    },
    xzqh: {
      deep: true,
      handler(newVal) {
        if (newVal.zs && newVal.qx == null) {
          this.search.county = newVal.zs.value;
        }
        if (newVal.zs && newVal.qx) {
          this.search.county = newVal.qx.value;
        }
        if (newVal.zs == null && newVal.qx == null) {
          this.search.county = null;
        }
        this.searchList();
      },
    },
    //土地用途
    tdyt: {
      deep: true,
      handler(newVal) {
        if (newVal.lv1 && newVal.lv2 == null) {
          this.search.type = newVal.lv1.code;
        }
        if (newVal.lv1 && newVal.lv2) {
          this.search.type = newVal.lv2.code;
        }
        if (newVal.lv1 == null && newVal.lv2 == null) {
          this.search.type = null;
        }
        this.searchList();
      },
    },
    "search.typeArr": {
      deep: true,
      handler(newVal) {
        if (newVal.length) {
          let len = newVal.length - 1;
          this.search.type = newVal[len];
        } else {
          this.search.type = "";
        }
      },
    },
    // "search.county": function (newVal, oldVal) {
    //   if (newVal != oldVal) {
    //     this.getPark();
    //   }
    // },
    search: {
      handler(val) {
        // if(val.minInvestmentEstimate!=10000&&val.maxInvestmentEstimate!=100000){
        //   this.estimateIndx=-2
        // }
        // if(val.minInvestmentEstimate!=100000&&val.maxInvestmentEstimate!=500000){
        //   this.estimateIndx=-2
        // }
        // if(val.minInvestmentEstimate!=500000&&val.maxInvestmentEstimate!=1000000){
        //   this.estimateIndx=-2
        // }
        // if(val.minInvestmentEstimate!=100000&&val.maxInvestmentEstimate!=''){
        //   this.estimateIndx=-2
        // }
      },
      deep: true,
      immediate: true,
    },
    countyName: function (val) {
      if (!val) {
        this.xzqh.zs = null;
        this.xzqh.qx = null;
        this.isXzqhShrink = true;
      }
    },
  },
  filters: {
    filter_statistical(value) {
      let value1 = 0;
      if (value > 10000) {
        value1 = (value / 10000).toFixed(1) + "万";
      } else {
        value1 = value;
      }
      return value1.toString();
    },
  },
  created() {
    window.addEventListener("keydown", this.handkeyCode, true); //开启监听键盘按下事件
  },
  mounted() {
    this.$nextTick(() => {
      let bn = document.getElementById("breadcrumb-nav");
      bn.style.width = "1405px";
    });
    this.restaurants = JSON.parse(sessionStorage.getItem("landSearchList"))
      ? JSON.parse(sessionStorage.getItem("landSearchList"))
      : [];
    if (!this.restaurants.length) {
      this.getSearchDefault();
    }
    this.getXzqh();
    this.getList();
    //this.getField("TDYT", "tdytList");

    this.gettdlx();
    this.getLabelList();
    this.getPark();
    // this.getCodeChildren("53", "cityList");
  },
  methods: {
    //搜索园区
    searchPark(item, index) {
      this.search.parkLevel =
        this.search.parkLevel == item.value ? null : item.value;
      if (item.name == "滇中新区") {
        this.search.parkCode = item.value;
        this.parkList = [];
        this.searchList();
      } else {
        this.search.parkCode = null;
        this.getPark();
      }
      if (item.name == "国家级" || item.name == "省级" || item.name == "其他") {
        this.isShrink = false;
      }
    },
    // 投资估算
    handleEstimate(item, index) {
      if (this.estimateIndx == index) {
        this.estimateIndx = -1;
        this.search.minInvestmentEstimate = null;
        this.search.maxInvestmentEstimate = null;
      } else {
        this.search.minInvestmentEstimate = item.minmoney;
        this.search.maxInvestmentEstimate = item.maxmoney;
        this.estimateIndx = index;
      }

      this.searchList();
    },
    // 模用地面积
    handleArea(item, index) {
      if (this.areaIndx == index) {
        this.search.minArea = null;
        this.search.maxArea = null;
        this.areaIndx = -1;
      } else {
        this.search.minArea = item.minarea;
        this.search.maxArea = item.maxarea;
        this.areaIndx = index;
      }

      this.searchList();
    },
    // 收起展开
    develop() {
      if (this.iconDown === "el-icon-arrow-up") {
        this.iconDown = "el-icon-arrow-down";
      } else {
        this.iconDown = "el-icon-arrow-up";
      }
      this.showList2 = !this.showList2;
    },
    //搜索默认值
    getSearchDefault() {
      searchDefault({ type: 1 }).then((res) => {
        if (res.data.success) {
          this.restaurants = res.data.data;
        }
      });
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    handleSelect(item) {},
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    changePark(val) {
      //如果有值查询
      if (val) {
        this.showParkList = true;
        getCountyParkList({
          parkName: this.parkName,
          divisionCode: this.search.county ? this.search.county : "",
        }).then((res) => {
          if (res.data.success) {
            this.countyParkList = res.data.data;
          }
        });
      } else {
        this.search.parkCode = "";
        this.searchList();
      }
    },
    selectCountyPark(item) {
      this.search.parkCode = item.parkCode;
      this.parkName = item.parkName;
      this.showParkList = false;
      this.searchList();
    },
    changeCounty(val) {
      if (val) {
        this.showList = true;
        getAdministrative({ name: val }).then((res) => {
          if (res.data.success) {
            this.countyList = res.data.data;
          }
        });
      } else {
        this.search.county = "";
        this.searchList();
      }
    },
    selectCounty(data) {
      this.search.county = data.code;
      this.countyName = data.name;
      this.showList = false;
      let childrenS = this.xzqhList[0].children;
      if (data.code.length == 4) {
        let index = childrenS.findIndex((item) => data.code == item.value);
        if (index != -1) {
          this.xzqh.zs = childrenS[index];
          this.isXzqhShrink = false;
        }
      }
      if (data.code.length == 6) {
        let str1 = data.code.slice(0, 4);
        let index = childrenS.findIndex((item) => str1 == item.value);
        if (index != -1) {
          this.xzqh.zs = childrenS[index];
          this.isXzqhShrink = false;
          let index1 = childrenS[index].children.findIndex(
            (item) => data.code == item.value
          );
          if (index1 != -1) {
            this.xzqh.qx = childrenS[index].children[index1];
          }
        }
      }
      this.searchList();
    },
    //切换排序
    changeSort(val) {
      // if (this.search.sort == val) {
      //   this.search.sort = null;
      // } else {
      //   this.search.sort = val;
      // }
      this.search.sort = val;
      this.search.sortFlag = !this.search.sortFlag;
      this.searchList();
    },
    changeSortFlag() {
      this.search.sortFlag = !this.search.sortFlag;
      this.searchList();
    },
    //选择交易状态
    changeTransaction(val) {
      if (this.search.transaction == val) {
        this.search.transaction = null;
      } else {
        this.search.transaction = val;
      }
    },

    getLabelList() {
      getLabelList({ type: 0, source: 2 }).then((res) => {
        if (res.data.success) {
          this.labelList = res.data.data;
        }
      });
    },
    //行政区划获取下级
    getCodeChildren(code, arrName) {
      getCodeChildren({ value: code }).then((res) => {
        if (res.data.success) {
          this["arrName"] = res.data.data;
        }
      });
    },
    getPark() {
      getCountyParkList({
        parkLevel: this.search.parkLevel ? this.search.parkLevel : "",
      }).then((res) => {
        if (res.data.success) {
          this.parkList = res.data.data;
        }
      });
    },
    gettdlx() {
      getTypeList().then((res) => {
        if (res.data.success) {
          this.tdytList = res.data.data;
        }
      });
    },
    // 加载功能引导
    guide() {
      let driver = new Driver();
      driver.defineSteps([
        {
          element: "#park-list-table-checkbox-1",
          popover: {
            title: "第一步：勾选地块，勾选两个以上",
            description: "需要勾选两个以上的地块才可以进行对比。",
            position: "left",
            doneBtnText: "确定",
            closeBtnText: "关闭",
            nextBtnText: "下一步",
            prevBtnText: "上一步",
          },
        },
        {
          element: "#badge-box-1",
          popover: {
            title: "第二步：点击对比",
            description:
              "勾选完地块后，点击这里，会弹出已选择的地块的列表，再点击对比按钮就可以开始对比啦。",
            position: "bottom",
            doneBtnText: "确定",
            closeBtnText: "关闭",
            nextBtnText: "下一步",
            prevBtnText: "上一步",
          },
        },
      ]);
      driver.start();
    },
    callBack() {
      this.isDetailedList = false;
    },
    getField(field, identification) {
      let data = { field: field };
      dictionaries(field).then((res) => {
        this[identification] = res.data.data;
      });
    },
    //获取行政区划
    getXzqh() {
      getXzqhList().then((res) => {
        if (res.data.success) {
          this.xzqhList = res.data.data;
        }
      });
    },
    detailedListsShow() {
      if (!this.contrastList.length) {
        this.$message.warning("请选择需要进行对比的地块！");
        // this.$confirm("您选择的园区为空，是否需要功能引导？").then(() => {
        //   this.guide();
        // });
      } else if (this.contrastList.length < 2) {
        this.$message.warning("请选择至少两个地块进行对比！");
      } else {
        this.isDetailedList = true;
      }
    },
    searchList1() {
      this.supplyPeriod1 = !this.supplyPeriod1;
      this.supplyPeriod2 = false;
      this.supplyPeriod3 = false;
      if (this.supplyPeriod1) {
        this.search.supplyPeriod = "1";
        this.searchList();
      } else {
        this.search.supplyPeriod = "";
        this.searchList();
      }
    },
    searchList2() {
      this.supplyPeriod2 = !this.supplyPeriod2;
      this.supplyPeriod1 = false;
      this.supplyPeriod3 = false;
      if (this.supplyPeriod2) {
        this.search.supplyPeriod = "2";
        this.searchList();
      } else {
        this.search.supplyPeriod = "";
        this.searchList();
      }
    },
    searchList3() {
      this.supplyPeriod3 = !this.supplyPeriod3;
      this.supplyPeriod1 = false;
      this.supplyPeriod2 = false;
      if (this.supplyPeriod3) {
        this.search.supplyPeriod = "3";
        this.searchList();
      } else {
        this.search.supplyPeriod = "";
        this.searchList();
      }
    },
    searchList() {
      // if (this.search.xzqh.length) {
      //   this.search.county = this.search.xzqh[this.search.xzqh.length - 1];
      // }
      this.search.current = 1;
      this.getList();
    },
    handkeyCode(e) {
      if (e.keyCode === 13) {
        this.getList();
      }
    },

    //刷新
    refreshList() {
      this.$refs["search"].resetFields();
      //this.search.xzqh = [];
      this.search.minArea = null;
      this.search.maxArea = null;
      this.search.name = "";
      this.search.parkCode = "";
      this.search.parkLevel = "";
      this.search.projectName = "";
      this.countyName = "";
      this.parkName = "";
      // this.search.type = "";
      // this.search.county = "";
      this.search.industryChainCategoryId = "";
      // this.search.sort = "";
      //this.search.sortFlag = true;
      this.xzqh = {
        //行政区划对象
        zs: null, //洲市
        qx: null, //区县
      };
      this.tdyt = {
        lv1: null, // 第一级
        lv2: null, //第二级
      };
      this.search.maxInvestmentEstimate = null;
      this.search.minInvestmentEstimate = null;
      this.search.industryChainCategoryId = null;
      this.areaIndx = -1;
      this.estimateIndx = -1;
      this.getList();
    },
    //切换页码
    handleCurrentChange(val) {
      this.search.current = val;
      this.getList();
    },

    //切换页条数
    handleSizeChange(val) {
      this.search.size = val;
      this.getList();
    },
    //添加需求
    releaseNeed() {
      this.$router.push({
        path: "/land/releaseNeed",
      });
    },

    async getList() {
      this.loading = true;
      let { data: res } = await projectList(this.search);
      if (res.success) {
        let list = res.data.records;
        this.total = res.data.total;

        list.forEach((item) => {
          if (item.pronounceImages) {
            let imgUrl =
              item.pronounceImages.length > 0
                ? systemConfig.imgServer +
                  systemConfig.imgApi +
                  item.pronounceImages[0].filePath
                : null;
            this.$set(item, "imgUrl", imgUrl);
            item.pronounceImages = item.pronounceImages
              ? item.pronounceImages
              : [];
            if (item.pronounceImages.length) {
              item.pronounceImages.forEach((itemFile) => {
                this.$set(
                  itemFile,
                  "url",
                  systemConfig.imgServer +
                    systemConfig.imgApi +
                    itemFile.filePath
                );
              });
            }
            if (item.pronounceVideos && item.pronounceVideos.length) {
              item.pronounceVideos.forEach((itemFile) => {
                this.$set(
                  itemFile,
                  "thumbnailSrc",
                  systemConfig.imgServer +
                    systemConfig.imgApi +
                    itemFile.thumbnail
                );
              });
            }
          }
          this.$set(item, "checked", 0);
          this.contrastList.forEach((cItem) => {
            if (item.id == cItem) {
              item.checked = 1;
            }
          });
        });

        this.tableList = list;

        this.loading = false;
      } else {
        this.$message.error("查询失败");
        this.loading = false;
      }
    },
    changeChecked(e, data) {
      if (e) {
        this.contrastList.push({ id: data.id, name: data.name });
      } else {
        let index = this.contrastList.findIndex((item) => item.id == data.id);
        this.contrastList.splice(index, 1);
      }
    },
    progressFormat(p) {
      return "" + p;
    },
    areaSliderChange(val) {
      this.search.maxArea = val[1];
      this.search.minArea = val[0];
    },
  },
  destroyed() {
    let bn = document.getElementById("breadcrumb-nav");
    bn.style.width = "";
  },
  // 缓存组件进如时
  activated() {
    let bn = document.getElementById("breadcrumb-nav");
    bn.style.width = "1405px";
  },
  // 缓存组件离开时
  deactivated() {
    let bn = document.getElementById("breadcrumb-nav");
    bn.style.width = "";
  },
};
</script>
<style scoped>
.imgStyle {
  width: 12px;
}

.park-list {
  width: 1335px;
  margin: 0 auto;
  background: #fff;
  padding: 10px 35px;
  position: relative;
  /* min-height: calc(100% - 60px); */
  min-height: calc(100% - 346px);
  /* height: auto; */
  display: inline-table;
}

.search-box {
  display: block;
}

.search-btn {
  display: flex;
  /* justify-content: flex-end; */
}

.badge-box {
  position: absolute;
  top: 100px;
  right: -66px;
}

.badge-img {
  width: 30px;
  height: 30px;
}

.table-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
}

.park-list-table {
  padding: 40px 0;
  border-bottom: 1px solid #c7c3c3;
  display: flex;
}

.park-list-table-checkbox {
  width: 30px;
  position: absolute;
  right: 7px;
}

::v-deep .el-checkbox__inner {
  width: 23px;
  height: 23px;
  border: 1px solid #626262;
}

.park-list-table-card {
  width: calc(100% - 50px);
}

::v-deep .el-checkbox__inner::after {
  height: 12px;
  width: 6px;
  top: 2px;
  left: 8px;
}

.park-list-table:hover {
  background: #f9f8f8;
}

.park-list-table:active {
  background-color: #00000010;
}

.page-box {
  margin: 40px 0 10px 0;
  display: flex;
  justify-content: center;
}

::v-deep .page-box .el-pager li {
  border: 1px solid #409eff;
}

::v-deep .el-pagination button:disabled {
  color: #fff;
  background: #409eff;
}

::v-deep .el-pagination .btn-prev {
  margin: 0 10px;
  padding-right: 8px;
}

::v-deep .el-pagination .btn-next {
  padding-left: 8px;
  margin: 0 10px;
}

::v-deep .el-pager li {
  padding: 0;
  margin: 0 4px;
}

.font-red {
  color: red;
  cursor: pointer;
  padding-right: 30px;
}

.park-list-table-no {
  margin-top: 10px;
  width: 100%;
}

.park-list-table-no-top {
  /* text-align: right; */
  border-bottom: 1px solid #c7c3c3;
  font-size: 0.8rem;
  font-weight: 600;
  height: 48px;
  line-height: 48px;
  display: flex;
  justify-content: space-between;
  /* position: relative; */
}

.comparison-switch {
  /* display: inline-block;
  position: absolute;
  left: 20px; */
  /* margin-left: 20px; */
  display: flex;
  align-items: center;
}

.screen-box {
  display: flex;
  height: 30px;
  line-height: 30px;
}

.screen-box-div {
  width: 70px;
  border: 1px solid #dcdfe6;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
  margin-left: 15px;
  font-size: 0.85rem;
  color: #606266;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: normal;
}

/* .screen-box > div:hover {
  background: #fff;
  border-color: #409eff;
  color: #409eff;
} */
.screen-box-active {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}

.screen-box-icon {
  color: #085393;
}

.park-list-table-no-c {
  width: 300px;
  margin: 100px auto 50px;
}

.park-list-table-no-c-img {
  width: 100%;
}

.park-list-table-no-c-img > img {
  width: 100%;
}

.park-list-table-no-c-span {
  margin: 0 auto;
  width: 50%;
  text-align: center;
  font-size: 0.75rem;
  color: #c7c3c3;
}

.park-list-table-no-c-btn {
  font-size: 0.85rem;
  width: 120px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  margin: 20px auto;
  background: #1a6ec2;
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
}

.contrast-list {
  position: fixed;
  top: 315px;
  right: 30px;
}

.card-info {
  font-size: 0.95rem;
  margin-left: 5px;
  max-width: 50%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.card-base {
  display: inline-block;
  position: relative;
  width: calc((100% - 80px) / 5);
  /* box-shadow: 0 0 4px #c7c3c3; */
  margin-top: 15px;
  border: 1px solid #efefef;
  border-radius: 4px;
  margin-right: 15px;
  height: 320px;
}

.card-mask {
  position: absolute;
  top: 12px;
  left: 12px;
  height: 162px;
  width: 245px;
  /* background: #b2b7b98c; */
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: 600;
}

.yjy-color {
  background: rgba(187, 253, 196, 0.4);
  /* color: rgb(10, 207, 116); */
  color: rgb(0, 114, 62);
}

.wjy-color {
  /* color: rgb(255, 89, 132); */
  color: rgb(209, 0, 54);
  background: rgba(255, 179, 199, 0.4);
}

.card-base-box {
  cursor: pointer;
  /* padding-top: 10px; */
  height: 100%;
}

.card-base-box-title {
  padding: 0 10px;
  width: calc(100% - 20px);
  font-size: 1.05rem;
  font-weight: bold;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #424243;
}

.card-base-box-center {
  padding: 0 10px;
  width: calc(100% - 20px);
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
}

.card-base-box-center-tag {
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 0.75rem;
  margin-right: 10px;
  margin-top: 10px;
  margin-bottom: 5px;
  max-width: calc(50% - 30px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-base-box-center-tag:last-child {
  margin-left: auto;
  margin-right: 0;
}

.tag1 {
  background: #dbffff;
  color: #26c6b8;
}

.tag2 {
  background: #ffdad4;
  color: #f43535;
}

.tag3 {
  background: #cae5ff;
  color: #3f8ff6;
}

.tag4 {
  background: #e1ddfe;
  color: #5d52f1;
}

.card-base-box-bottom {
  padding: 15px 10px;
  width: calc(100% - 20px);
  border-top: 1px solid #d3d3d3;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-base-box-top {
  height: calc(100% - 45px);
}

.card-base-box-bottom-r {
  font-size: 0.8rem;
  color: #3186f6;
  cursor: pointer;
}

.card-base-box-bottom-l {
  font-size: 0.8rem;
  color: #4a3e3e;
  width: calc(100% - 100px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-title {
  margin: 2px 5px;
  font-size: 1.05rem;
  font-weight: bold;
  display: inline-block;
  width: calc(100% - 10px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.pageView {
  display: flex;
  justify-content: flex-end;
  width: 85px;
  text-align: right;
  cursor: pointer;
  padding: 5px 10px;
  /* margin: 10px 10px 5px; */
}

.color-4 {
  color: red;
}

.color-1 {
  color: #f4420a;
}

.color-2 {
  color: #ff6941;
}

.color-3 {
  color: #ff9001;
}

>>> .pageView .el-progress__text {
  color: #bfbfbf;
  margin: -13px 8px 8px -15px;
}

.need-area {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 27px;
}

.need-area-slider {
  display: inline-block;
  width: 100px;
  margin: 0 5px;
}

.need-area-input {
  width: 100px;
  display: inline-block;
  padding: 8px 8px;
}

.left-top {
  max-width: 80px;
  line-height: 20px;
  height: 20px;
  position: absolute;
  left: 17px;
  top: 18px;
  background: #e56810;
  padding: 0 10px;
  border-radius: 4px;
  font-size: 0.75rem;
  color: white;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.left-top span {
}

.right-top {
  position: absolute;
  right: 16px;
  top: 17px;
  padding: 2px 6px;
  background: #00000059;
  border-radius: 5px;
  font-size: 0.75rem;
}

.right-bottom {
  position: absolute;
  right: 16px;
  top: 150px;
  padding: 2px 6px;
  background: #00000059;
  border-radius: 5px;
  font-size: 0.75rem;
  color: #fff;
}

.right-top span {
  color: white;
}

.text-bottom {
  height: 30px;
  /*position: relative;*/
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
}

.text-center {
  /*height: 20px;*/
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.text-bottom .price {
  /*position: absolute;*/
  /*left: 12px;*/
  /*top: 2px;*/
}

.text-bottom .price span {
  color: red;
  font-weight: bold;
}

.title-select {
  border: 1px solid #bfbfbf;
  padding: 20px 10px;
}

.tool-title {
  color: #979797;
  margin-top: 10px;
  display: inline-block;
}

.content {
  /*position: relative;*/
}

.input-box {
  position: absolute;
  top: 43px;
  left: 105px;
  background: #fff;
  /* border: 1px solid #e4e7ed; */
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  width: 200px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 99999;
}

.input-box > div {
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  font-size: 0.8rem;
  cursor: pointer;
}

.content span {
  color: #7c7c7c;
  display: inline-block;
  margin: 10px;
  cursor: pointer;
  font-weight: bold;
  font-size: 0.95rem;
}

.content span:hover {
  color: #58aec3;
}

.content .span-active {
  color: #1bbafd;
}

.content2 {
  margin-top: 10px;
}

.content2 span {
  font-weight: unset;
}

.bottom-line-dashed {
  border-bottom: 1px dashed #b5b5b5;
  position: relative;
}

.shrink {
  overflow: hidden;
  /* height: 88px; */
  height: 44px;
  /*position: relative;*/
}

.shrink-child {
  height: 0;
}

.more {
  position: absolute;
  right: 0px;
  top: 10px;
  font-size: 0.95rem;
  color: #00d2fd;
  cursor: pointer;
}

.shrink-btn {
  position: absolute;
  right: 0px;
  bottom: 10px;
  font-size: 0.95rem;
  color: #00d2fd;
  cursor: pointer;
}

.search-button {
  height: 28px;
  background: red;
  margin-left: 20px;
  line-height: 28px;
  padding: 0 20px;
  border-radius: 4px;
  font-weight: normal;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.search-button:hover {
  /*opacity: 0.5;*/
}

.search-button-bgc1 {
  background: #18a7e9;
}

.search-button-bgc2 {
  background: #f5a702;
}

.search-button-bgc3 {
  background: #00baaf;
}

.select-bgc {
  /*opacity: 0.5;*/
  background: #f72e2e;
  /*font-weight: bold;*/
}

.develop {
  font-size: 0.85rem;
  cursor: pointer;
  margin-left: 10px;
}

.availableNear {
  background: #00baaf;
}

.available {
  background: #009ee7;
}

.availability {
  background: #f5a702;
}

.park-detail-top-title3-li1 {
  border-radius: 4px;
  /*background: #ff4c4c;*/
  color: #fff;
  text-align: center;
}

.park-detail-top-title3-span1 {
  text-align: center;
  align-items: center;
  font-size: 0.85rem;
  width: 70px;
  /*padding: 0 10px;*/
  height: 25px;
  /*font-weight: 600;*/
  /*padding: 5px;*/
  line-height: 28px;
  display: flex;
  justify-content: center;
  /*margin: 10px 5px;*/
  margin-left: 5px;
  margin-top: 5px;
}

.el-tag--mini {
  height: 25px;
  line-height: 25px;
  margin-top: 5px;
}
</style>
